import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPanelComponent } from './config-panel.component';
import { NotificationAccessControlComponent } from './notification-access-control/notification-access-control.component';
import {ReactiveFormsModule} from "@angular/forms";
import {CheckboxModule} from "primeng/checkbox";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {ToastModule} from "primeng/toast";
import {ConfigPanelService} from "./config-panel.service";

@NgModule({
  declarations: [ConfigPanelComponent, NotificationAccessControlComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CheckboxModule,
        ButtonModule,
        RippleModule,
        ToastModule
    ],
    providers: [ConfigPanelService]
})
export class ConfigPanelModule { }
